export default class Hider {
  public static hide(element: HTMLElement, allowNulls?: boolean): void {
    if (!element) {
      if (!allowNulls) {
        console.trace("Attempting to hide null element");
      }
      return;
    }

    if (element.classList.contains("hidden")) return;
    element.classList.add("hidden");
  }

  public static show(element: HTMLElement, allowNulls?: boolean): void {
    if (!element) {
      if (!allowNulls) {
        console.trace("Attempting to show null element");
      }
      return;
    }

    element.classList.remove("hidden");
  }

  public static match(element: HTMLElement, shouldShow: boolean): void {
    if (shouldShow) {
      this.show(element);
    } else {
      this.hide(element);
    }
  }
}
